var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaAds(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4931_117665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.94421 7.86919C1.94421 8.55516 2.0951 9.08182 2.29226 9.40042C2.5508 9.81775 2.93632 9.99453 3.32944 9.99453C3.83646 9.99453 4.30031 9.86891 5.19413 8.63509C5.91026 7.64618 6.75408 6.25797 7.32178 5.38772L8.2833 3.91333C8.9512 2.8894 9.72422 1.75116 10.6106 0.979579C11.3341 0.349825 12.1147 0 12.9002 0C14.2192 0 15.4754 0.762807 16.437 2.19347C17.4892 3.76028 18 5.73382 18 7.77046C18 8.98119 17.7609 9.87081 17.354 10.5737C16.9609 11.2534 16.1947 11.9325 14.9059 11.9325V9.99453C16.0095 9.99453 16.2849 8.98246 16.2849 7.82421C16.2849 6.17368 15.8993 4.34189 15.0499 3.03312C14.447 2.1047 13.6659 1.53747 12.8064 1.53747C11.8769 1.53747 11.1289 2.23712 10.2882 3.48484C9.84129 4.14765 9.38243 4.95544 8.86732 5.86688L8.30018 6.86961C7.16091 8.88561 6.87234 9.34477 6.30274 10.1026C5.3043 11.4296 4.45184 11.9325 3.32944 11.9325C1.99807 11.9325 1.15608 11.3571 0.634711 10.49C0.209039 9.78337 0 8.85628 0 7.79986L1.94421 7.86919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5332 2.33025C2.42463 0.959018 3.71092 0 5.18629 0C6.0408 0 6.89017 0.252421 7.77716 0.975228C8.74734 1.76547 9.78142 3.06681 11.0715 5.21158L11.5342 5.98119C12.6508 7.83797 13.2861 8.79312 13.658 9.24365C14.1362 9.82211 14.4711 9.99453 14.9061 9.99453C16.0097 9.99453 16.2851 8.98246 16.2851 7.82421L18.0002 7.77046C18.0002 8.98119 17.7612 9.87081 17.3543 10.5737C16.9612 11.2534 16.195 11.9325 14.9061 11.9325C14.1049 11.9325 13.3951 11.7588 12.6102 11.0197C12.0067 10.4525 11.3013 9.44477 10.7586 8.53888L9.14418 5.84751C8.33425 4.49684 7.59119 3.48982 7.16123 3.03368C6.69871 2.5433 6.10401 1.95102 5.15507 1.95102C4.38705 1.95102 3.73476 2.48898 3.18892 3.31172L1.5332 2.33025Z",
    fill: "url(#paint0_linear_4931_117665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15475 1.95102C4.38673 1.95102 3.73444 2.48898 3.1886 3.31172C2.41685 4.47439 1.94421 6.20611 1.94421 7.86919C1.94421 8.55516 2.0951 9.08182 2.29226 9.40042L0.634711 10.49C0.209039 9.78337 0 8.85628 0 7.79986C0 5.87874 0.528328 3.87649 1.53295 2.33025C2.42438 0.959018 3.71067 0 5.18604 0L5.15475 1.95102Z",
    fill: "url(#paint1_linear_4931_117665)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4931_117665",
    x1: 3.8185,
    y1: 6.67432,
    x2: 16.1976,
    y2: 7.30076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4931_117665",
    x1: 2.8168,
    y1: 8.6838,
    x2: 2.8168,
    y2: 4.12329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4931_117665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaAds);
export default __webpack_public_path__ + "static/media/meta-ads.cb49f1fe6ef4668c78632a7b061407d5.svg";
export { ForwardRef as ReactComponent };